import { add, fromNumber, type MonetaryValue } from 'ezmoney';

export const sumMonetaryValues = (
  currency: string,
  monetaryValues: MonetaryValue[],
): MonetaryValue =>
  monetaryValues.reduce(
    (sum, monetaryValue) =>
      monetaryValue.currency === currency ? add(sum, monetaryValue) : sum,
    fromNumber(0, currency, 2),
  );

export const monetaryValuesHaveSameCurrency = (
  monetaryValues: MonetaryValue[],
): boolean => {
  if (monetaryValues.length === 0) {
    return true;
  }

  const currency = monetaryValues[0].currency;
  return monetaryValues.every((value) => value.currency === currency);
};
